import React from 'react';
import { useSelector } from 'react-redux';

import { commentsModel } from '../model';
import { CommentsPreviewSideBarContainer } from './CommentsPreviewSideBarContainer';
import { useTiptapEditor } from '../../../entities/tiptap-editor';

export const CommentsPreviewSideBar = () => {
  const commentsFlow = useSelector(commentsModel.selectors.selectCommentsFlow);
  const { editor } = useTiptapEditor();

  if (!commentsFlow || !editor) return null;

  return <CommentsPreviewSideBarContainer editor={editor} />;
};
